export function locationIndexValidate(location){
    var result = true;

    result = validateId(location.id);
    if(!result) return result;

    result = validateName(location.name);
    if(!result) return result;

    return result;
}

function validateId(id) {    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateName(name) {
    if( typeof name == "string") return true;
    else return false;
} 
